import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { componentKey as addFundsKey, setOpenPrepayFundAccessConfirmationModal, setSelectedCard } from '../AddFundsSlice'
import styles from "../AddFunds.styles"
import BasicCard from '../../../../../components/card/basiccard/BasicCard'
import { VEC_ICON_NAME } from '../../../../../components/icons/constants'
import Heading from '../../../../../components/heading/Heading'
import VerticalSeparator from '../../../../../components/separator/verticalseparator/VerticalSeparator'
import TextInput from '../../../../../components/input/textinput/TextInput'
import Label from '../../../../../components/label/Label'
import Button from '../../../../../components/button/Button'
import { MINIMUM_PREPAY_THRESHOLD, PLACE_OF_ORIGIN_FOR_PAYMENT } from '../../constants'
import { BUTTON_TYPE } from '../../../../../components/button/constants'
import commonStyles from "../../PaymentDrawer.styles"
import { componentKey as paymentDrawerKey } from '../../PaymentDrawerSlice'
import { addPrepayBalance, calculateSalesTaxForStripe, getStripeSavedCards } from '../AddFundsSaga'
import { HEADING } from '../../../../../components/heading/constants/constants'
import { addNotifications } from '../../../../toaster/ToasterPortalSlice'
import SavedCardsList from '../../../../../components/savedcardslist/SavedCardsList'
import { componentKey as authenticationComponentKey} from '../../../../authentication/AuthenticationSlice'

export const AddFundsSavedCardsList = ({
    placeOfOriginforpayment = PLACE_OF_ORIGIN_FOR_PAYMENT.SUBMIT_FORM_PAGE,
    onPayNowCb = () => { },
}) => {

    const dispatch = useDispatch();

    const { signedInUser } = useSelector((state) => state[authenticationComponentKey])
    const { stripeSavedCardsList, selectedCard, enteredAmount, stripeCardDetails } = useSelector(state => state[addFundsKey]);

    const { billingDetails, disableEnterAmountField, prepayThreshold } = useSelector(state => state[paymentDrawerKey]);
    const { FilingFee, TINMatchFee, StateFee, USPSFee, eDeliveryFee } = billingDetails;

    const payNowHandler = () => {
        if (!Number(enteredAmount) || Number(enteredAmount) < prepayThreshold) {
            dispatch(addNotifications({ heading: "Error", message: `Please enter an amount more than $${MINIMUM_PREPAY_THRESHOLD}` }));
            return;
        }

        if (disableEnterAmountField) {
            onPayNowCb({
                card_id: stripeCardDetails?.id,
                amount: enteredAmount,
                placeOfOriginforpayment,
                addressDetails: stripeCardDetails?.billing_details,
                Customer: stripeCardDetails?.customer,
            });
        } else {
            if (signedInUser.UserType == 3) {
                dispatch(setOpenPrepayFundAccessConfirmationModal(true))
            } else {
                dispatch(addPrepayBalance({
                    card_id: stripeCardDetails?.id,
                    amount: enteredAmount,
                    placeOfOriginforpayment: PLACE_OF_ORIGIN_FOR_PAYMENT.SUBMIT_FORM_PAGE,
                    addressDetails: stripeCardDetails?.billing_details,
                    Customer: stripeCardDetails?.customer,
                }))
            }
        }
    }

    return (
        <>

            {stripeSavedCardsList?.length ? <>

                <SavedCardsList isEditable={false} cardsList={stripeSavedCardsList} selectedCard={selectedCard} onSelectCb={(cardObj) => {
                    dispatch(setSelectedCard(cardObj))}
                    } />

                <div style={styles.paynowBtnContainer}>
                    <Button type={BUTTON_TYPE.PRIMARY} onClickCb={payNowHandler} style={commonStyles.nextButton} disabled={selectedCard ? false : true}>
                        Pay Now
                    </Button>
                </div>
            </>

                :

                <div className='text-center mt-5'>
                    <Heading type={HEADING.H3}>No Saved Cards Available</Heading>
                </div>
            }
        </>
    )
}
